export const createLeadsRepository = (appFetch) => {
    return {
        visitLead(body, options = {}) {
            return appFetch.post('/cabinet/leads/api/visitors', body, options);
        },
        calcLead(body, options = {}) {
            return appFetch.post('/cabinet/leads/api/calc', body, options);
        },
        formLead(body, options = {}) {
            return appFetch.post('/cabinet/leads/api/lead-forms', body, options);
        },
    };
};
